import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class StafsetningView extends Component {
	render() {
		return (
			<MalidCard title={window.l('stafsetning_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0) && !this.props.frontPage}
				frontPage={this.props.frontPage}
				aboutText={window.l('stafsetning_about')}
				database="stafsetning">
				{
					this.props.data && this.props.data.map((item, index) => {
						let fletta = item.fletta;

						if (item.ordskipting) {
							let ordskipting = item.ordskipting;

							let parts = ordskipting.map((o, i) => {
								return i === 0 ? fletta.slice(0, o) : fletta.slice(ordskipting[i-1], o)
							});
							parts.push(fletta.slice(ordskipting[ordskipting.length-1]));

							fletta = parts.join('<span class="ohlut-separator">|</span>')
						}

						return <p className="card-text" key={index}>
							{
								item.sja && item.sja.length > 0 &&
								<span dangerouslySetInnerHTML={{__html: fletta}}/>
							}
							{
								(!item.sja || item.sja.length === 0) &&
								<a target='_blank' href={'//stafsetning.arnastofnun.is/fletta/'+item.id}><strong><span dangerouslySetInnerHTML={{__html: fletta}}/></strong></a>
							}
							{
								item.adgreiningarnumer && <React.Fragment> {item.adgreiningarnumer}</React.Fragment>
							}
							{
								item.ordflokkur && <React.Fragment> {item.ordflokkur}</React.Fragment>
							}
							{
								item.l_framburdur && <React.Fragment> [-l:-]</React.Fragment>
							}
							{
								item.greinir &&
								<React.Fragment> {item.greinir};</React.Fragment>
							} {item.kennimyndir}<em> {item.daemi ? item.daemi.split('|').join('·') : ''}</em> {
								item.einnig && item.einnig.length > 0 &&
								<React.Fragment> (einnig ritað {item.einnig.map(function(einnig, eIndex) {
									return <React.Fragment key={eIndex}>
										{
											eIndex > 0 &&
											<React.Fragment> ,</React.Fragment>
										}<Link to={'/leit/'+einnig.visun}>{einnig.visun}</Link>
									</React.Fragment>

								})})</React.Fragment>
							} {
								item.sja && item.sja.length > 0 &&
								<React.Fragment> → {item.sja.map(function(sja, eIndex) {
									return <React.Fragment key={eIndex}>
										{
											eIndex > 0 &&
											<React.Fragment> ,</React.Fragment>
										}<Link to={'/leit/'+sja.visun}>{sja.visun}</Link>
									</React.Fragment>

								})}</React.Fragment>
							}
							{
								item.stigbreyting_annad &&
								<React.Fragment> STIGB {item.stigbreyting_annad}</React.Fragment>
							}
							{
								item.ritreglur && item.ritreglur.map(function(ritregla, rIndex) {
									return <React.Fragment>{rIndex > 0 && <React.Fragment>,</React.Fragment>} (sjá <a target='_blank' href={'http://ritreglur.arnastofnun.is/#'+ritregla.regla}>§ {ritregla.regla}</a> í Ritreglum)</React.Fragment>
								})
							}
						</p>
					})
				}
			</MalidCard>
		);
	}
}

export default StafsetningView;



// WEBPACK FOOTER //
// ./src/components/StafsetningView.js